import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import _ from 'lodash';

import {
  RenderField,
  RenderSubmitButton,
  RenderCheckboxRadioField,
  RenderTextareaField,
  RenderDropdownSelect,
} from '../../form';
import * as Validations from '../../form/commonValidations';
import AddressFields from '../../form/AddressFields';

import { Tabs, Pane } from '../../ui/tabs';
import GenericAccordion from '../../ui/GenericAccordion';
import GuestAffiliation from '../../../manage/guestlist/GuestAffiliation';
import RenderEventInvitations from './RenderEventInvitations';
import RenderGuests from './RenderGuests';
import RenderRsvpQuestion from './RenderRsvpQuestion';
import RenderRSVP from './RenderRSVP';

import namecardNoName from '../../../../assets/images/doodles/namecard_no_name.svg';

function splitLines(text) {
  return (
    <div className="margin-left envelope-recipient">
      {text.split('\n').map((str, key) => (
        <span key={key}>{str}</span>
      ))}
    </div>
  );
}
const paneKeyToIndex = {
  GUESTS: 0,
  CONTACT: 1,
  ENVELOPE: 1,
  RSVP: 2,
};

class EditGuestGroupForm extends React.Component {
  constructor(props) {
    super(props);

    this.onToggleEdit = this.onToggleEdit.bind(this);
    this.state = {
      editEnvelopeRecipient: false,
    };
  }

  onToggleEdit() {
    const { editEnvelopeRecipient } = this.state;
    this.setState({
      editEnvelopeRecipient: !editEnvelopeRecipient,
    });
  }

  render() {
    const {
      wedding,
      handleSubmit,
      hasErrors,
      pristine,
      initialValues,
      submitting,
      valid,
      initialPanel,
      guestFormValues,
      rsvpQuestions,
      eventFormValues,
      handleEventInvitation,
      onAddGuest,
      events,
      invitedFormValue,
      activeEventTab,
      onUninvite,
    } = this.props;
    const { editEnvelopeRecipient } = this.state;

    const checkedEvents = eventFormValues
      .filter(event => event.checked === true)
      .map(event => events.byId[event.event_id]);

    const accordionItems = checkedEvents.map((event, index) => ({
      heading: event.name.length > 50 ? `${event.name.slice(0, 50)}...` : event.name,
      body: (
        <div>
          <FieldArray
            name="guests"
            component={RenderRSVP}
            mealOptions={event.meal_options.map(mealOption => ({
              value: mealOption.id,
              title: _.capitalize(mealOption.name),
            }))}
            eventId={event.id}
          />
          <ul className="list-unstyled">
            {rsvpQuestions &&
              rsvpQuestions.orderedIds
                .filter(id => rsvpQuestions[id].event_id === event.id)
                .map(rsvpQuestionId => (
                  <RenderRsvpQuestion
                    key={rsvpQuestionId}
                    question={rsvpQuestions[rsvpQuestionId]}
                  />
                ))}
          </ul>
        </div>
      ),
      open: activeEventTab ? event.id === activeEventTab : index === 0,
    }));

    return (
      <form onSubmit={handleSubmit} className="edit-guest-group-form">
        <Tabs selected={paneKeyToIndex[initialPanel] || 0} disabled={hasErrors}>
          <Pane label="Guest Info">
            <div>
              <FieldArray
                name="guests"
                component={RenderGuests}
                guestFormValues={guestFormValues}
                onAddGuest={type => onAddGuest(type, eventFormValues)}
              />
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <div className="visible-xs visible-sm">
                    <Field
                      name="affiliation"
                      id="add-guest-group-guest-affiliation-test"
                      component={RenderDropdownSelect}
                      options={GuestAffiliation(
                        wedding.owner_first_name,
                        wedding.partner_first_name
                      )}
                      label="Relationship To You"
                      tooltip="Indicate how you know your guests to help filter your list."
                      hideEmpty
                    />
                  </div>
                  <div className="visible-md visible-lg">
                    <Field
                      name="affiliation"
                      id="add-guest-group-guest-affiliation-test"
                      component={RenderDropdownSelect}
                      options={GuestAffiliation(
                        wedding.owner_first_name,
                        wedding.partner_first_name
                      )}
                      label="Relationship To You"
                      tooltip="Indicate how you know your guests to help filter your list."
                      hideEmpty
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div
                  className="with-tooltip margin-right-2x"
                  data-tooltip='Tame your guest list with these filters by marking who&apos;s "Definitely" and "Maybe" invited.'
                >
                  <span className="form-label wedding-label">Invited?</span>
                  <i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline margin-right-2x" />
                </div>
                <div style={{ display: 'inline-block' }}>
                  <span
                    className="with-tooltip no-tooltip-on-mobile margin-right-2x"
                    data-tooltip='These are guests you cannot imagine your wedding without. Using our online RSVP feature on your wedding website? Guests marked as "Definitely" will be able to RSVP online.'
                  >
                    <Field
                      id="add-guest-group-invited-definitely"
                      name="invited"
                      component={RenderCheckboxRadioField}
                      type="radio"
                      label="Definitely"
                      styleOverride
                      value="true"
                      inline
                    />
                  </span>
                  <span
                    className="with-tooltip no-tooltip-on-mobile"
                    data-tooltip='These are the guests you’re still thinking over. Using our online RSVP feature on your wedding website? Guests marked as "Maybe" will NOT be able to RSVP online.'
                  >
                    <Field
                      id="add-guest-group-invited-maybe"
                      name="invited"
                      component={RenderCheckboxRadioField}
                      type="radio"
                      label="Maybe"
                      styleOverride
                      value="false"
                      onChangeAction={() => onUninvite(guestFormValues)}
                      inline
                    />
                  </span>
                </div>
              </div>
              {eventFormValues.length > 0 && (
                <div
                  className={`form-group${
                    invitedFormValue === 'false' ? ' form-group-disabled' : ''
                  }`}
                >
                  <div className="event-invitations">
                    <FieldArray
                      name="event_invitations"
                      component={RenderEventInvitations}
                      label="Events Invited To"
                      id="event-invitations"
                      eventFormValues={eventFormValues}
                      handleEventInvitation={(eventInvitation, eventIndex) =>
                        handleEventInvitation(guestFormValues, eventInvitation, eventIndex)
                      }
                      disabled={invitedFormValue === 'false'}
                    />
                  </div>
                </div>
              )}
            </div>
          </Pane>
          <Pane label="Contact Info & Invitations">
            <div>
              {editEnvelopeRecipient && (
                <div className="visible-xs visible-sm">
                  <Field
                    name="envelope_recipient_override"
                    label="Name As Appears On The Outer Envelope"
                    id="edit-guest-group-envelope_recipient_override"
                    type="text"
                    placeholder={initialValues.envelope_recipient}
                    component={RenderTextareaField}
                    styleOverride
                    tooltip="We formatted your guests' info for your outer envelopes, but feel free to edit how you'd like any of these to appear, including editing titles."
                  />
                </div>
              )}
              {editEnvelopeRecipient && (
                <div
                  className="with-tooltip no-tooltip-on-mobile edit-guest-name visible-md visible-lg"
                  data-tooltip="We formatted your guests' info for your outer envelopes, but feel free to edit how you'd like any of these to appear, including editing titles."
                >
                  <Field
                    name="envelope_recipient_override"
                    label="Name As Appears On The Outer Envelope"
                    id="edit-guest-group-envelope_recipient_override"
                    type="text"
                    placeholder={initialValues.envelope_recipient}
                    component={RenderTextareaField}
                    styleOverride
                  />
                </div>
              )}
              {!editEnvelopeRecipient && (
                <div className="envelope-recipient-container visible-md visible-lg">
                  <div className="form-label">
                    <div className="visible-xs-inline visible-sm-inline">
                      Name as appears on the outer envelope
                    </div>
                    <div
                      className="with-tooltip"
                      data-tooltip="We formatted your guests' info for your outer envelopes, but feel free to edit how you'd like any of these to appear, including editing titles."
                    >
                      <i className="zolaicon zolaicon-info visible-xs visible-sm" />
                      <span className="hidden-xs hidden-sm form-label">
                        Name as appears on the outer envelope
                      </span>
                    </div>
                  </div>
                  <div className="envelope margin-top padding-bottom-2x">
                    {splitLines(initialValues.envelope_recipient)}
                    <i onClick={this.onToggleEdit} className="zolaicon zolaicon-edit" />
                    {/* <i onClick={this.onToggleEdit} className="glyphicon glyphicon-pencil" /> */}
                  </div>
                </div>
              )}
            </div>
            <div className="mailing-address">
              <AddressFields
                selector="editGuestGroupForm"
                minimal
                optional
                addressMessage="Formally addressing your invitations? Avoid Rd, St, Apt, etc."
              />
            </div>
            <div className="row margin-bottom">
              <div className="col-xs-12 col-md-6">
                <Field
                  name="email_address"
                  label="Email"
                  id="edit-guest-group-email"
                  type="email"
                  component={RenderField}
                  validate={Validations.MAX_LENGTH_100}
                />
              </div>
              <div className="col-xs-12 col-md-6">
                <Field
                  name="mobile_phone"
                  label="Mobile"
                  id="edit-guest-group-mobile-phone"
                  type="tel"
                  component={RenderField}
                  validate={Validations.MAX_LENGTH_25}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="form-label margin-right-2x" style={{ minWidth: '200px' }}>
                Sent save the date?
              </span>
              <Field
                id="edit-guest-group-save-the-date-sent-yes"
                name="save_the_date_sent"
                component={RenderCheckboxRadioField}
                type="radio"
                label="Yes"
                styleOverride
                value="true"
                inline
              />
              <Field
                id="edit-guest-group-save-the-date-sent-no"
                name="save_the_date_sent"
                component={RenderCheckboxRadioField}
                type="radio"
                label="No"
                styleOverride
                value="false"
                inline
              />
            </div>
            <div className="form-group">
              <span className="form-label margin-right-2x" style={{ minWidth: '200px' }}>
                Sent wedding invitation?
              </span>
              <Field
                id="edit-guest-group-invitation-sent-yes"
                name="invitation_sent"
                component={RenderCheckboxRadioField}
                type="radio"
                label="Yes"
                styleOverride
                value="true"
                inline
              />
              <Field
                id="edit-guest-group-invitation-sent-no"
                name="invitation_sent"
                component={RenderCheckboxRadioField}
                type="radio"
                label="No"
                styleOverride
                value="false"
                inline
              />
            </div>
          </Pane>
          {events.orderedIds.length === 0 ? (
            <Pane label="RSVP Status">
              <div className="rsvp-status no-invites">
                <div>
                  <img src={namecardNoName} alt="Namecard with no name" />
                </div>
                <div className="no-invites-header">
                  <h3>You haven&#39;t Created Any Events</h3>
                </div>
                <div className="no-invites-copy">
                  When you do, you can build guest lists and manage RSVPs... all right here
                </div>
              </div>
            </Pane>
          ) : (
            <Pane label="RSVP Status">
              {accordionItems.length > 0 ? (
                <GenericAccordion items={accordionItems} allowMultiple />
              ) : (
                <div className="rsvp-status no-invites">
                  <div>
                    <img src={namecardNoName} alt="Namecard with no name" />
                  </div>
                  <div className="no-invites-header">
                    <h3>You haven&#39;t Invited Your Guest to Any Events!</h3>
                  </div>
                  <div className="no-invites-copy">
                    When you invite a guest to an event, you&#39;ll be able to see and edit their
                    RSVP response here
                  </div>
                </div>
              )}
            </Pane>
          )}
        </Tabs>
        <div className="edit-guest-group-submit-container">
          <div className="pull-right edit-guest-group-submit">
            <RenderSubmitButton
              className="edit-guest-submit"
              pristine={pristine}
              submitting={submitting}
              valid={valid}
            />
          </div>
        </div>
      </form>
    );
  }
}

EditGuestGroupForm.propTypes = {
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string.isRequired,
    partner_first_name: PropTypes.string.isRequired,
  }),
  handleSubmit: PropTypes.func.isRequired,
  hasErrors: PropTypes.bool,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialPanel: PropTypes.string,
  initialValues: PropTypes.shape({}),
  invitedFormValue: PropTypes.string,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  eventFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  rsvpQuestions: PropTypes.shape({}),
  handleEventInvitation: PropTypes.func,
  onAddGuest: PropTypes.func,
  events: PropTypes.shape({}),
  activeEventTab: PropTypes.number,
  onUninvite: PropTypes.func,
};

export default EditGuestGroupForm;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/EditGuestGroupForm.jsx